const _ = require('lodash');

/**
 * Stable stringify function that sorts keys to ensure deterministic output.
 * @param {any} value
 * @returns {string|undefined}
 */
const stableStringify = function(value) {
    // Arrays
    if (_.isArray(value)) {
        const arrRes = _.map(value, item => {
            const str = stableStringify(item);
            return str === undefined ? 'null' : str;
        });
        return '[' + arrRes.join(',') + ']';
    }

    // Plain Objects
    if (_.isPlainObject(value)) {
        // Handle toJSON if it exists
        if (_.isFunction(value.toJSON)) {
            return stableStringify(value.toJSON());
        }

        const parts = [];
        // Sort keys using lodash to ensure stability
        const keys = _.sortBy(_.keys(value));
        
        _.forEach(keys, (key) => {
            const val = value[key];
            
            // JSON.stringify skips functions and undefined values in objects
            if (_.isFunction(val) || _.isUndefined(val)) {
                return;
            }
            
            const strVal = stableStringify(val);
            if (strVal !== undefined) {
                parts.push(JSON.stringify(key) + ':' + strVal);
            }
        });
        
        return '{' + parts.join(',') + '}';
    }

    // Primitive types and special objects (Date, RegExp, etc.)
    return JSON.stringify(value);
};

module.exports = {
    stableStringify
};